import { render, staticRenderFns } from "./OAuth2.vue?vue&type=template&id=6982b20e"
import script from "./OAuth2.vue?vue&type=script&lang=js"
export * from "./OAuth2.vue?vue&type=script&lang=js"
import style0 from "./OAuth2.vue?vue&type=style&index=0&id=6982b20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports